(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/actions/last-searched.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/actions/last-searched.js');
"use strict";


const _RTK = RTK,
  createAction = _RTK.createAction;
const addGameToLastSearched = createAction('lastsearched/add');
const clearLastSearched = createAction('lastsearched/clear');
setGlobal('svs.components.casino_react.casinoStore.actions.lastSearched', {
  addGameToLastSearched,
  clearLastSearched
});

 })(window);